import {
  SpeedDialIcon as SpeedDialIconMui,
  SpeedDialIconProps as SpeedDialIconPropsMui,
} from '@mui/material';

export type SpeedDialIconProps = SpeedDialIconPropsMui;

export function SpeedDialIcon({ ...rest }: SpeedDialIconProps) {
  return <SpeedDialIconMui {...rest} />;
}
